import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CoreModule } from 'src/app/core/core.module';
import { DensityInputNumberComponent } from './density-input-number/density-input-number.component';
import {
    DsAccordionModule,
    DsBadgeModule,
    DsBannerModule,
    DsBoxModule,
    DsButtonModule,
    DsCheckboxModule,
    DsFormFieldModule,
    DsFormsModule,
    DsHintModule,
    DsIconModule,
    DsLabelModule,
    DsListItemModule,
    DsMenuModule,
    DsTabsModule,
    DsToggleButtonModule,
    DsRadioGroupModule,
    DsSwitchModule,
    DsTagModule,
    DsModalModule,
    DsLoadingAreaModule,
    DsPopoverModule,
    DsRangeSliderModule,
    DsSegmentedControlComponent,
    DsSegmentedControlItemComponent,
    DsSegmentedControlModule,
    DsStepperModule,
    DsTooltipDirectiveModule
} from '@bmw-ds/components';
import { DensityHelpAccordionComponent } from './density-help-accordion/density-help-accordion.component';
import { NoCommaNumberPipe } from '../pipes/no-comma-number-pipe';
import { DensityDropdownComponent } from './density-dropdown/density-dropdown.component';
import { DensityDatepickerComponent } from './density-datepicker/density-datepicker.component';
import { DensityFilterPopoverComponent } from './density-filter-modal/density-filter-popover.component';
import { DensityInputTextComponent } from './density-input-text/density-input-text.component';
import { DensityInputTextAreaComponent } from './density-input-text-area/density-input-text-area.component';
import { DensityConfirmationDialogComponent } from './density-confirmation-dialog/density-confirmation-dialog.component';
import { DensityUserPickerComponent } from './density-user-picker/density-user-picker.component';
import { DeleteAnalysisDialogComponent } from '../ui/delete-analysis-dialog/delete-analysis-dialog.component';

@NgModule({
    declarations: [
        DensityInputNumberComponent,
        DensityHelpAccordionComponent,
        NoCommaNumberPipe,
        DensityDropdownComponent,
        DensityDatepickerComponent,
        DensityFilterPopoverComponent,
        DensityConfirmationDialogComponent,
        DensityUserPickerComponent,
        DeleteAnalysisDialogComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        CoreModule,
        TranslateModule,
        DsFormsModule,
        DsAccordionModule,
        DsRangeSliderModule,
        DsBadgeModule,
        DsButtonModule,
        DsTooltipDirectiveModule,
        DsIconModule,
        DsStepperModule,
        DsFormFieldModule,
        DsPopoverModule,
        DsBoxModule,
        DsListItemModule,
        DsSegmentedControlModule,
        DsMenuModule,
        DsBannerModule,
        DsTabsModule,
        DensityInputTextAreaComponent,
        DsToggleButtonModule,
        DsRadioGroupModule,
        DsSwitchModule,
        DsTagModule,
        DensityInputTextComponent,
        DsModalModule,
        DsLoadingAreaModule
    ],
    exports: [
        DsSegmentedControlItemComponent,
        DsSegmentedControlComponent,
        DensityInputNumberComponent,
        DensityInputTextAreaComponent,
        DensityHelpAccordionComponent,
        DensityDropdownComponent,
        DsBadgeModule,
        DensityDatepickerComponent,
        DsCheckboxModule,
        DsLabelModule,
        DsHintModule,
        DsButtonModule,
        DsTooltipDirectiveModule,
        DsIconModule,
        DsStepperModule,
        DsFormFieldModule,
        DsSegmentedControlModule,
        DsPopoverModule,
        DsBoxModule,
        DsListItemModule,
        DsMenuModule,
        DsRangeSliderModule,
        DensityFilterPopoverComponent,
        DsBannerModule,
        DsTabsModule,
        DsToggleButtonModule,
        NoCommaNumberPipe,
        DsRadioGroupModule,
        DsSwitchModule,
        DsTagModule,
        DensityInputTextComponent,
        DensityConfirmationDialogComponent,
        DeleteAnalysisDialogComponent,
        DsModalModule,
        DsLoadingAreaModule,
        DensityUserPickerComponent
    ]
})
export class DensitySharedModule {}
